export default __webpack_public_path__ + "static/image-project-tracking-page-d4f75106dd0b48fbaaf91d5cb3a44778.png";